export enum QualityEnum {
  SATISFACTORY = 1,
  GOOD = 2,
  VERYGOOD = 3,
}
